<template>
  <Modal
    :id="'cmp-distribution-reports-account_report_form'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('accounts')}}</template>
    <template slot="body">
      <SearchList
        :id="'accounts'"
        ref="searchList"
        :items="accounts"
        :keyProperty="'account_id'"
        :label="'account_name'"
        :selectionNumber="'multiple'"
        @selected="onRowClicked"
        @searched="searchLabel"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onSave">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { ReportService } from "../../services/reports.service";
export default {
  components: {
    SearchList,
    Modal,
  },

  data: function () {
    return {
      accounts: [],
      selectedAccounts: [],
    };
  },

  mounted: function () {
    ReportService.getAccounts({ str: "" }).then((data) => {
      this.accounts = data.data.accounts.filter((l) => l.account_name != "");
    });
  },
  computed: {},
  methods: {
    searchLabel: function (searchString) {
      ReportService.getAccounts({
        str: searchString,
      }).then((data) => {
        this.accounts = data.data.accounts.filter((l) => l.account_name != "");
      });
    },
    onSave: async function () {
      this.$emit("selected", {
        action: "account",
        items: this.selectedAccounts,
      });
    },
    onRowClicked: async function (account) {
      this.selectedAccounts = [];
      const account_ids = Array.from(account);
      account_ids.forEach((id) => {
        const account = this.accounts.find((a) => a.account_id == id);
        this.selectedAccounts.push(account);
      });
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-reports-account_report_form {
  .select-all-row {
    padding-top: 20px !important;
  }

  .dt-table2 {
  --body-height: 350px !important;
  }
}
</style>
